import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import './payments.css'

import { DomainContext } from '../../domain-repository/DomainRepository'

import { saveSessionEnd, setPageId } from '../../services/Metrics'

import withLang from '../../withLang'
import TrackingPage from '../../components/TrackingPage'
import { PaymentsForm } from './PaymentsForm'

function PaymentsPage(props) {
  const { t } = useTranslation()

  const {
    reservation,
  } = useContext(DomainContext)


  return (
    <div className="container">
      <div className="row justify-content-center text-center">
        <div className="col-5 mt-5">
          <div>
            <img onClick={() => props.history.push('/start')} src={require(`../../assets/images/logo.png`)} alt="Guerin" className="img-fluid pt-3 pb-3" />
          </div>
        </div>
      </div>
      <PaymentsForm nextPageUrl='/thank-you' />
    </div>
  )
}

// export default withLang(TrackingPage(PaymentsPage, 100))
export default withLang(PaymentsPage)
